module.exports = __webpack_public_path__ + "img/IMG-20200223-WA0010.5d105ba5.jpg";